/**
 * @description 所有全局配置的状态管理，如无必要请勿修改
 */
import defaultSettings from 'settings';
import { findSort } from 'resfull/product/product';
const { keepAliveList, isBreadcrumb, isTagsView, isFixedHead, isLogo, isCollapse, isMenuMini, isUniqueOpened, isUserPhoto, layoutSet, themeSet, loadingTimer, subMenuTheme, isSplitMenu, isGrayscale, isInvert, isWartermark, wartermarkText } = defaultSettings;
const state = () => ({
    // ==========================
    layoutConfig: {
        isBreadcrumb: isBreadcrumb, // 是否开启 Breadcrumb
        isTagsView: isTagsView, // 是否开启 Tags-View
        isFixedHead: isFixedHead, // 是否固定 Header
        isLogo: isLogo, // 是否侧边栏 Logo
        isCollapse: isCollapse, // 是否折叠导航菜单
        isMenuMini: isMenuMini, // column布局和ce布局下的左侧导航是否缩放60px显示
        isUniqueOpened: isUniqueOpened, // 是否只保持一个子菜单的展开
        isUserPhoto: isUserPhoto, // 是否显示登录用户头像
        layoutSet: layoutSet, // 切换布局：1、 classic 经典布局 2、 fashion 时尚布局 3、 elegant 典雅布局 4、 strange 怪异布局
        themeSet: themeSet, // 布局样式 0、default 默认 1、green 绿色 2、glory 橙色 3、ocean 蓝色 4、dark 黑夜模式
        layoutLoading: false, // 切换布局时的 loading
        loadingTimer: loadingTimer, // 切换布局时的 loading 时间
        subMenuTheme: subMenuTheme, // 菜单主题颜色 1、 dark 暗色  2、 light 亮色
        isSplitMenu: isSplitMenu, // 自动菜单分割(仅 classic 经典布局生效)
        isGrayscale: isGrayscale, // 灰色模式
        isInvert: isInvert, // 色弱模式
        isWartermark: isWartermark, // 开启水印
        wartermarkText: wartermarkText, // 水印文案
    },
    keepAliveList: keepAliveList,
    // ==========================
    device: 'desktop',
    staticizeBtn: { content: 'false' },
});
const getters = {
    device: state => state.device,
    layoutConfig: state => state.layoutConfig,
    keepAliveList: state => state.keepAliveList,
    staticizeBtn: state => state.staticizeBtn,
};
const mutations = {
    // 触发 layoutConfig 配置更新
    changeLayoutConfig(state, layoutConfig) {
        if (layoutConfig) {
            state.layoutConfig = Object.assign(state.layoutConfig, layoutConfig);
        } else {
            console.warn('layoutConfig 配置缺失!');
        }
    },
    changeWartermarkText(state, text) {
        state.layoutConfig.wartermarkText = text;
    },
    changeStaticizeBtn(state, text) {
        state.staticizeBtn = text;
    },
};
const actions = {
    setStaticizeBtn({ commit }, text) {
        findSort(text).then(res => {
            const { data } = res;
            if (data && data.length) {
                commit('changeStaticizeBtn', data[0]);
            }
        });
    },
    changeLayoutConfig({ commit }, layoutConfig) {
        commit('changeLayoutConfig', layoutConfig);
    },
    changeWartermarkText({ commit }, text) {
        commit('changeWartermarkText', text);
    },
};
export default { state, getters, mutations, actions };
